"use client";

import { type ReactElement } from "react";
import { type Social } from "../../lib/types";
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
} from "../ui/tooltip";

interface FooterSocialProps {
  social: Social;
}

function FooterSocial({
  social,
}: Readonly<FooterSocialProps>): ReactElement | null {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <a href={social.url} target="_blank" rel="nofollow">
            <img
              src={social.logo}
              alt={`Logo ${social.name}`}
              width={24}
              height={24}
            />
            <span className="sr-only">{social.name}</span>
          </a>
        </TooltipTrigger>
        <TooltipContent>{social.name}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export { FooterSocial };
